// export const parseGraphqlError = error => {
//   return error.toString().split(':')[2];
// };

export const parseGraphqlError = error => {
  // Handle Apollo Client GraphQL errors
  if (error?.graphQLErrors?.length) {
    return (
      error.graphQLErrors[0]?.extensions?.exception?.response?.message ||
      error.graphQLErrors[0]?.message
    );
  }

  // Handle raw GraphQL response format
  if (error?.errors?.[0]?.message) {
    return (
      error.errors[0]?.extensions?.exception?.response?.message ||
      error.errors[0]?.message
    );
  }

  // Handle network errors
  if (error?.networkError?.message) {
    return error.networkError.message;
  }

  // Handle basic error objects
  if (error?.message) {
    return error.message;
  }

  return 'Something went wrong. Please try again.';
};
